import React from 'react';
import NoDataTileBody from 'commons/src/components/tile/NoDataTileBody';
import { SensorValueTileContent } from 'commons/src/models/commonTypeScript';
import LargeSensorValue from './LargeSensorValue';
import PublicDashboardTileHeader from './TileHeader';

export type Props = {
    tile: SensorValueTileContent;
    numberOfTilesInWidth: number;
    id: string;
};

export const PublicDashboardSensorValueTileComponent = (props: Props): React.ReactElement => {
    const { tile, id, numberOfTilesInWidth } = props;
    const { serialNumber, currentSensorValue, segmentName, locationName } = tile;

    let tileBody;
    if (!currentSensorValue) {
        tileBody = <NoDataTileBody message="NotEnoughData" />;
    } else {
        const { value, type, unit } = currentSensorValue;

        tileBody = (
            <LargeSensorValue
                sensorValue={value}
                sensor={type}
                unit={unit}
                key={`sensor-component-${serialNumber}-${type}`}
                numberOfTilesInWidth={numberOfTilesInWidth}
                id={id}
            />
        );
    }

    return (
        <div className="tile-wrapper">
            <PublicDashboardTileHeader
                headerText={segmentName}
                subHeaderText={locationName}
                id={id}
                numberOfTilesInWidth={numberOfTilesInWidth}
            />
            <div className="tile-body">{tileBody}</div>
        </div>
    );
};

export default PublicDashboardSensorValueTileComponent;
